export interface ICurrency {
    code: string;
    symbol: string;
}

const currenciesCodelist: Array<ICurrency> = [
    {
        code: 'CZK',
        symbol: 'Kč',
    },
    {
        code: 'EUR',
        symbol: '€',
    },
    {
        code: 'USD',
        symbol: '$',
    },
    {
        code: 'GBP',
        symbol: '£',
    },
    {
        code: 'PLN',
        symbol: 'zł',
    },
    {
        code: 'HUF',
        symbol: 'Ft',
    },
    {
        code: 'RUB',
        symbol: '₽',
    },
    {
        code: 'UAH',
        symbol: '₴',
    },
    {
        code: 'CHF',
        symbol: 'CHF',
    },
    {
        code: 'SEK',
        symbol: 'kr',
    },
    {
        code: 'NOK',
        symbol: 'kr',
    },
    {
        code: 'DKK',
        symbol: 'kr',
    },
    {
        code: 'HRK',
        symbol: 'kn',
    },
    {
        code: 'RON',
        symbol: 'lei',
    },
    {
        code: 'BGN',
        symbol: 'лв',
    },
    {
        code: 'TRY',
        symbol: '₺',
    },
    {
        code: 'AUD',
        symbol: '$',
    },
    {
        code: 'BRL',
        symbol: 'R$',
    },
    {
        code: 'CAD',
        symbol: '$',
    },
    {
        code: 'CNY',
        symbol: '¥',
    },
    {
        code: 'HKD',
        symbol: '$',
    },
    {
        code: 'IDR',
        symbol: 'Rp',
    },
    {
        code: 'ILS',
        symbol: '₪',
    },
    {
        code: 'INR',
        symbol: '₹',
    },
    {
        code: 'KRW',
        symbol: '₩',
    },
    {
        code: 'MXN',
        symbol: '$',
    },
    {
        code: 'MYR',
        symbol: 'RM',
    },
    {
        code: 'NZD',
        symbol: '$',
    },
    {
        code: 'PHP',
        symbol: '₱',
    },
];

export default currenciesCodelist;
